import querystring from 'querystring';
import axios from 'axios';

// const API_DEMO = 'https://apus.now.sh';
const API_PRODUCTION = 'https://api.apus.agency';

const buildURL = path => {
  if (path.indexOf('http') > -1) {
    return path;
  }

  if (path[0] !== '/') {
    throw new Error('Prepend path with forward slash');
  }

  return `${API_PRODUCTION}${path}`;
};

const fetchContent = url => {
  return fetch(buildURL(url)).catch(e => {
    console.error(e);
  });
};

const sendData = (url, body) => {
  return fetch(buildURL(url), {
    body: querystring.stringify(body),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    method: 'POST',
  }).catch(e => {
    console.error(e);
  });
};

const sendFormData = (url, values) => {
  const formData = new FormData();
  Object.keys(values).forEach(key => {
    const value = values[key];
    if (value) {
      formData.append(key, value);
    }
  });

  return axios.post(buildURL(url), formData).catch(e => {
    console.error(e);
  });
};

const api = {
  fetch: url => fetchContent(url),
  home: () => fetchContent('/ru/home'),
  cases: category => fetchContent(`/ru/cases?_limit=4&_page=1${category ? `&category=${category}` : ''}`),
  case: id => fetchContent(`/ru/cases/${id}`),
  news: () => fetchContent('/ru/news?_limit=4&_page=1'),
  newsPost: id => fetchContent(`/ru/news/${id}`),
  maps: () => fetchContent('/ru/maps'),
  offices: () => fetchContent('/ru/offices'),
  team: () => fetchContent('/ru/team'),
  features: () => fetchContent('/ru/features'),
  clients: () => fetchContent('/ru/clients'),
  services: () => fetchContent('/ru/services'),
  about: () => fetchContent('/ru/about'),
  approach: () => fetchContent('/ru/approach'),
  jobs: () => fetchContent('/ru/jobs'),
  vacancy: id => fetchContent(`/ru/jobs/vacancies/${id}`),
  links: () => fetchContent(`/system/menu-links-ru`),
  seoMetaData: path => fetchContent(`/seo?path=${path}`),
  subscribeToNews: values => sendData('/netcat/add.php', values),
  sendVacancyForm: values => sendFormData(`/netcat/add.php`, values),
  sendBriefForm: values => sendData(`/netcat/add.php`, values),
};

export default api;



// WEBPACK FOOTER //
// ./src/utils/api.js